import { render, staticRenderFns } from "./addOtherPost.vue?vue&type=template&id=0db2aab8&scoped=true&"
import script from "./addOtherPost.vue?vue&type=script&lang=js&"
export * from "./addOtherPost.vue?vue&type=script&lang=js&"
import style0 from "./addOtherPost.vue?vue&type=style&index=0&id=0db2aab8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2aab8",
  null
  
)

export default component.exports